'use client';

import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from '@weareconceptstudio/core';

const LazySection = ({ children, fallback, threshold = 0.1, delay = 2000 }) => {
	const { translate } = useTranslation();
	const { ref, inView } = useInView({
		triggerOnce: true,
		threshold,
		delay,
	});
	const resolvedFallback = fallback ?? <div>{translate('common.loadingContent')}</div>;

	return <div ref={ref}>{inView ? children : resolvedFallback}</div>;
};

export default LazySection;
